import axios from 'axios';
import Cookies from 'js-cookie';
const API_URL = `${process.env.REACT_APP_API_URL}/api/clientportal/v1/auth`;



  const setToken=(token)=>{
    Cookies.set('admone_cp', JSON.stringify(token), { 
      expires: 1 / 12, 
      // expires: 15 / 1440,
      path: '/',
      // domain: process.env.REACT_APP_COOKIE_URL || undefined,
      // secure: secureFlag,  // Set secure flag
    
    }); 
  }

const setUserDetails = (res) => {
  
    const id = res.data.user.user.id;
    const name = res.data.user.user.name;
    const email = res.data.user.user.email;
    const phone = res.data.user.user.phone;


    // const client = res.data.user.user.clients;
    const acesssToken = res.data.user.token.access.token;
    const refreshToken = res.data.user.token.refresh.token;
    const middleName = res.data.user.user.surname;
     localStorage.setItem("userName", name);
    localStorage.setItem("middleName", middleName);
    localStorage.setItem("email", email);
    localStorage.setItem("phone", phone);


    localStorage.setItem("userId", id);
    // localStorage.setItem("client", client);
    //  localStorage.setItem("token", acesssToken);
    // localStorage.setItem("refreshToken",refreshToken);
 
  // setAccessToken(acesssToken);
  // setRefreshToken(refreshToken);

  };
  
  const login = async (data ) => {
   const res = await axios.post(API_URL + "/login",data)

  // 2FA is on and the password was only step 1 (a code is owed, or SMS setup
  // is required first): no tokens in this response, so there is nothing to
  // store yet. The caller hands off to the next screen.
  if (!res.data?.user?.token) {
    return res;
  }

  const tokens = {
    accessToken: res.data.user.token.access.token,
    refreshToken:  res.data.user.token.refresh.token
  };
      setToken(tokens)
    setUserDetails(res);
  
    return res;

}


// Step 2 of the password login: submit the SMS code with the challenge issued
// at step 1. The response is shaped like /login, so token handling is identical.
const verifyTwoFactor = async (data) => {
  const res = await axios.post(API_URL + "/verify-2fa", data);

  const tokens = {
    accessToken: res.data.user.token.access.token,
    refreshToken: res.data.user.token.refresh.token
  };
  setToken(tokens);
  setUserDetails(res);

  return res;
}


// SMS setup after the deadline, before there is a session: text a code to the
// number on file, then confirm it. Confirming finishes the login, so its
// response is shaped like /login.
const setupSmsSend = async (data) => {
  const res = await axios.post(API_URL + "/2fa/setup/sms/send", data);
  return res.data;
}

const setupSmsConfirm = async (data) => {
  const res = await axios.post(API_URL + "/2fa/setup/sms/confirm", data);

  const tokens = {
    accessToken: res.data.user.token.access.token,
    refreshToken: res.data.user.token.refresh.token
  };
  setToken(tokens);
  setUserDetails(res);

  return res;
}


const resendTwoFactor = async (data) => {
  const res = await axios.post(API_URL + "/resend-2fa", data);
  return res.data;
}


// Tell the server which method the user picked. Sends the SMS; a no-op for the
// authenticator, which already has the secret.
const startTwoFactor = async (data) => {
  const res = await axios.post(API_URL + "/2fa/start", data);
  return res.data;
}


// ── Passkey login (step 2) ─────────────────────────────────────────────────
// Authorised by the same short-lived challenge as the code path, so neither
// call can be aimed at an account whose password has not been cleared.
const passkeyLoginBegin = async (data) => {
  const res = await axios.post(API_URL + "/2fa/passkey/login/begin", data);
  return res.data;
}

const passkeyLoginVerify = async (data) => {
  const res = await axios.post(API_URL + "/2fa/passkey/login/verify", data);

  const tokens = {
    accessToken: res.data.user.token.access.token,
    refreshToken: res.data.user.token.refresh.token
  };
  setToken(tokens);
  setUserDetails(res);

  return res;
} 


// Forget the session in this browser only.
const clearLocalSession = () => {
  localStorage.removeItem("userName");
  localStorage.removeItem("middleName");

  localStorage.removeItem("userId");
  localStorage.removeItem("client");
  // localStorage.removeItem("token");

  Cookies.remove('admone_cp', { path: '/' });
}

// Ends the session on the server too, so the token stops working even if a
// copy of it survives somewhere. The browser side is cleared whatever the API
// says: a failed call must not leave someone stuck signed in.
const logout = async ( ) => {
  try {
    const { accessToken } = JSON.parse(Cookies.get('admone_cp') || '{}');
    if (accessToken) {
      await axios.post(API_URL + "/logout", {}, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
    }
  } catch (error) {
    console.error('Logout call failed:', error.message);
  }
  clearLocalSession();
} 



 const RefreshToken = async (data ) => {
    const res = await axios.post(API_URL + "/refreshToken",data)
    

    const tokens = {
      accessToken: res.data.token.access.token,
      refreshToken:  res.data.token.refresh.token
    };
        setToken(tokens)
     
     return res;
 
 }


/**
 * Step 2 of the passwordless email-OTP login.
 *
 * Lives here rather than in forgetPassword.service because this is the point a
 * session is created, and the cookie/localStorage helpers are here. The old
 * caller stored nothing at all, so a client who logged in this way ended up on
 * a protected page with no token - which also meant the 2FA setup screen could
 * not call its own endpoints.
 *
 * The response shape differs from /login: this endpoint returns
 * { user, token, ... } flat, where /login nests them under `user`.
 */
const verifyLoginOtp = async (data) => {
  const res = await axios.post(API_URL + "/verifyOtp", data, {
    headers: { 'Content-Type': 'application/json' },
  });

  // Still owing a second factor: no tokens in this response, nothing to store.
  if (res.data?.twoFactorRequired) {
    return res.data;
  }

  if (res.data?.token) {
    setToken({
      accessToken: res.data.token.access.token,
      refreshToken: res.data.token.refresh.token,
    });
  }

  const u = res.data?.user;
  if (u) {
    localStorage.setItem("userName", u.name);
    localStorage.setItem("middleName", u.surname);
    localStorage.setItem("email", u.email);
    localStorage.setItem("phone", u.phone);
    localStorage.setItem("userId", u.id);
  }

  return res.data;
}


const LoginAuth={
    
    login,verifyLoginOtp,verifyTwoFactor,setupSmsSend,setupSmsConfirm,resendTwoFactor,startTwoFactor,passkeyLoginBegin,passkeyLoginVerify,RefreshToken,logout,clearLocalSession

}

export default LoginAuth